import React, { useEffect, useState } from 'react';
import { useFetch } from '../../useFetch';
import { getNews } from '../model/homepageBffRepository';
import reportError from '../../../client/tracking/errorReporter';
import NewsAndAds from './NewsAndAds';
import NewsAndAdsSkeleton from './NewsAndAdsSkeleton';
import { withRelease } from '../../../shared/releaseContext';
import { FEATURE_FLAGS_PROP_TYPES } from '../../../shared/experiments/phasedRelease/config';
import { getCookie } from '../../../client/cookie/cookieService';
import { logError } from '../../../shared/log';

export const NewsAndAdsContainer = ({ featureFlags }) => {
  const [articlesCache, setArticlesCache] = useState({});
  const [preferredState, setPreferredState] = useState();
  const { articles } = articlesCache;

  const { error } = useFetch(
    () => (articles ? Promise.resolve(articles) : getNews(featureFlags).then(setArticlesCache)),
    (e) => reportError(e, 'Could not load news'),
    20000,
  );

  useEffect(() => {
    let userPreferredState;
    try {
      userPreferredState = getCookie('ads_params_state');
    } catch (err) {
      logError(err);
    }

    setPreferredState(userPreferredState ?? 'null');
  }, []);

  if (preferredState && articles?.length && !error) {
    return <NewsAndAds articles={articles} preferredState={preferredState} />;
  }

  return error ? null : <NewsAndAdsSkeleton />;
};

NewsAndAdsContainer.propTypes = {
  featureFlags: FEATURE_FLAGS_PROP_TYPES,
};

export default withRelease()(NewsAndAdsContainer);
